module.exports = __webpack_public_path__ + "img/circle2.95f8b19d.svg";